import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState:any = {
    
    quotes:{},
      
}

const quotesSlice = createSlice({
  name: 'quotes',
  initialState,
  reducers: {
    setQuotes(state,action:PayloadAction<any>){
      state.quotes = action.payload;
    }
  },

});

// Reducer
export default quotesSlice.reducer;

// Actions
export const {setQuotes} = quotesSlice.actions;

